export const FETCH_MASTER_DATA_REQUEST = 'FETCH_MASTER_DATA_REQUEST'
export const FETCH_MASTER_DATA_FAILURE = 'FETCH_MASTER_DATA_FAILURE'
export const FETCH_MASTER_DATA_SUCCESS = 'FETCH_MASTER_DATA_SUCCESS'
